import { combine, createEvent, createStore, sample } from 'effector'
import {
  NotificationPayload,
  showNotification,
} from 'src/features/notifications'
import { fx } from 'src/libs'
import {
  PaymentTraffic,
  TrafficMonitoringLoad,
  TrafficMonitoringResponse,
} from 'src/pages/billing/paymentTrafficMonitoring/types'

export const loadMonitoringList = createEvent<TrafficMonitoringLoad>()
export const updateMonitoringList = createEvent<TrafficMonitoringResponse>()
export const resetMonitoringList = createEvent()

export const getMonitoringListFx = fx<
  TrafficMonitoringLoad,
  TrafficMonitoringResponse
>({
  method: 'GET',
  url: '/payment-traffic',
})

export const getMonitoringListCSVFx = fx<
  TrafficMonitoringLoad,
  { items: PaymentTraffic[]; total: number }
>({
  method: 'GET',
  url: '/payment-traffic',
})

export const $monitoringList = createStore<PaymentTraffic[]>([])
  .on(updateMonitoringList, (_, { items }) => items)
  .reset(resetMonitoringList)

export const $totalCountOfMonitoringList = createStore<number>(0)
  .on(updateMonitoringList, (_, { total }) => total)
  .reset(resetMonitoringList)

export const $computedAt = createStore<string | null>(null)
  .on(updateMonitoringList, (_, { computedAt }) => computedAt)
  .reset(resetMonitoringList)

export const $loadingMonitoringList = combine(
  getMonitoringListFx.pending,
  $computedAt,
  (pending, computedAt) => pending && computedAt === null,
)

sample({
  clock: loadMonitoringList,
  fn: ({ limit, page, filters, order }) => ({
    query: {
      order,
      limit: String(limit),
      page: String(page),
      where: JSON.stringify(filters ?? {}),
    },
  }),
  target: getMonitoringListFx,
})

sample({
  clock: getMonitoringListFx.doneData,
  source: $computedAt,
  filter: (computedAt, { body }) => computedAt !== body.computedAt,
  fn: (_, { body }) => body,
  target: updateMonitoringList,
})

sample({
  clock: [getMonitoringListFx.failData, getMonitoringListCSVFx.failData],
  fn: (error): NotificationPayload => ({
    type: 'error',
    message: 'Request failed',
    description: error?.body?.message ?? 'Request failed',
  }),
  target: showNotification,
})
